import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CashLoan } from '../Module/CashLoan.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CashLoanService {
  private get apiUrl(): string {
    return `${environment.apiUrl}/loans`;
  }

  constructor(private http: HttpClient) {}

  addLoan(loan: CashLoan): Observable<CashLoan> {
    return this.http.post<CashLoan>(this.apiUrl, loan);
  }
  
  getLoansByClient(clientId: number): Observable<CashLoan[]> {
    return this.http.get<CashLoan[]>(`${this.apiUrl}/client/${clientId}`);
  }

  getTotalLoaned(clientId: number): Observable<number> {
    return this.http.get<number>(`${this.apiUrl}/client/${clientId}/total`);
  }
  
  getPagedLoans(
    page: number,
    size: number,
    clientName?: string,
    status?: boolean | null,
    date?: string | null
  ): Observable<any> {
    let params: any = {
      page: page,
      size: size
    };

    if (clientName) {
      params.clientName = clientName;
    }

    if (status !== null && status !== undefined) {
      params.status = status;
    }

    if (date) {
      params.date = date;
    }

    return this.http.get<any>(`${this.apiUrl}/paged`, { params });
  }

  countLoans(): Observable<number> {
    return this.http.get<number>(`${this.apiUrl}/count`);
  }
  
  getPaymentSummary(): Observable<{ paid: number; unpaid: number }> {
    return this.http.get<{ paid: number; unpaid: number }>(`${this.apiUrl}/payment-summary`);
  }
  
  getLoanById(id: number): Observable<CashLoan> {
    return this.http.get<CashLoan>(`${this.apiUrl}/${id}`);
  }

  updateLoan(id: number, loan: CashLoan): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/${id}`, loan);
  }
  
  getPagedLoansForClient(
    clientId: number,
    page: number,
    size: number,
    keyword?: string,
    status?: string,
    date?: string
  ): Observable<any> {
    let params = new HttpParams()
      .set('page', page)
      .set('size', size);

    if (keyword) params = params.set('keyword', keyword);
    if (status !== undefined && status !== null) params = params.set('status', status);
    if (date) params = params.set('date', date);

    return this.http.get<any>(`${this.apiUrl}/client/${clientId}/paged`, { params });
  }
  
  bulkPayLoans(ids: number[]): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/pay`, ids);
  }
}
